import { render, staticRenderFns } from "./livepic.vue?vue&type=template&id=20614506&scoped=true&"
import script from "./livepic.vue?vue&type=script&lang=js&"
export * from "./livepic.vue?vue&type=script&lang=js&"
import style0 from "./livepic.vue?vue&type=style&index=0&id=20614506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20614506",
  null
  
)

export default component.exports